import { minorAmountToMajor } from "@/lib/checkout-price";
import { isBrowserThirdPartyTelemetrySuppressed } from "@/lib/telemetry-route-policy";

export type CheckoutEventContext = {
  /** Meta/browser event id used for Pixel/CAPI dedup and Razorpay-note fallback. */
  event_id: string;
  /** Meta Pixel option uses camelCase while backend/API payloads use snake_case. */
  eventId: string;
};

declare global {
  interface Window {
    fbq?: (
      event: string,
      name: string,
      params?: Record<string, unknown>,
      options?: { eventID?: string }
    ) => void;
  }
}

export function createCheckoutEventContext(existingEventId?: string): CheckoutEventContext {
  const eventId = existingEventId || newCheckoutEventId();
  return { event_id: eventId, eventId };
}

export function trackMetaPurchase(
  checkoutEvent: CheckoutEventContext,
  amount: number,
  currency?: string
): void {
  if (typeof window === "undefined" || !window.fbq || isBrowserThirdPartyTelemetrySuppressed())
    return;
  // Two-argument callers are legacy INR-only surfaces and pass major units.
  // Currency-aware checkout callers pass provider minor units + ISO currency.
  const value = currency ? minorAmountToMajor(amount, currency) : amount;
  window.fbq(
    "track",
    "Purchase",
    { value, currency: currency ?? "INR" },
    { eventID: checkoutEvent.eventId }
  );
}

function newCheckoutEventId(): string {
  const randomUUID = globalThis.crypto?.randomUUID?.bind(globalThis.crypto);
  if (randomUUID) return randomUUID();
  return `checkout_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 12)}`;
}
